import { Component, Input, Output, OnInit, EventEmitter } from "@angular/core";
import * as _ from "lodash";

@Component({
  selector: "fields-group",
  templateUrl: "./fields-group.component.html",
})
export class FieldsGroupComponent implements OnInit {

  @Input() public group: any;
  @Input() public registrations: any[] = [];
  @Input() public depth: number = 1;

  @Output() public onRelationChange: EventEmitter<any> = new EventEmitter();
  @Output() public onToggleGroup: EventEmitter<any> = new EventEmitter();

  public ngOnInit() {
    console.log(this.group);
  }

  public toggleClass(event: any, cssclass: string) {
    const elem = event.target;
    const parent = elem.closest(".group-toggle");
    parent.classList.toggle(cssclass);
  }

  public editFieldRegistrationEvent(event) {
      if (!event.done) {
        let index = -1;
        event.group.registrations.forEach((r, i) => {
          if (r === event.registration.registrationId) {
            index = i;
          }
        });
        if (index !== -1) {
          event.group.registrations.splice(index, 1);
        } else {
          event.group.registrations.push(event.registration.registrationId);
        }
      }
      event.done = true;
      this.onRelationChange.emit(event);
  }

  public childrensContain(registrationId: string, items: any[]) {
    if (!items.length) {
      return false;
    }
    for (let i = 0; i < items.length; i++) {
      if ((Array.isArray(items[i].registrations) && !items[i].registrations.length) || items[i].registrations.includes(registrationId)) {
        return true;
      } else if (Array.isArray(items[i].registrations) && items[i].registrations.length && !items[i].registrations.includes(registrationId)) {
        return false;
      } else {
        if (!items[i].components) {
          if (!items[i].registrations || !items[i].registrations.hasOwnProperty(registrationId)) {
            return false;
          }
        } else {
          this.childrensContain(registrationId, items[i].components);
        }
      }
    }
    return true;
  }

  public getIncludes(registrations: string[], value: string) {
    return registrations && registrations.includes(value);
  }

  public onGroupClick(registration, components): void {
    const status = this.childrensContain(registration.registrationId, components);
    const items = this.getItemsList([], components);

    items.forEach((item) => {
      let index = -1;
      item.registrations.forEach((r, i) => {
        if (r === registration.registrationId) {
          index = i;
        }
      });
      if (status) {
        if (index !== -1) {
          item.registrations.splice(index, 1);
        }
      } else {
        if (index === -1) {
          item.registrations.push(registration.registrationId);
        }
      }
    });

    this.onToggleGroup.emit({
      registration,
      items,
      status: !status,
    });
  }

  private getItemsList(items: any[], components): any[] {
    components.forEach((c) => {
      if (!c.components) {
        items.push(c);
      } else {
        items.concat(this.getItemsList(items, c.components));
      }
    });
    return items;
  }

}
